export default "__VITE_ASSET__CQzatz3C__"